// extracted by mini-css-extract-plugin
export var root = "Icon-module--root--36GMZ";
export var swim = "Icon-module--swim--3udb-";
export var bike = "Icon-module--bike--1YwNr";
export var run = "Icon-module--run--VjlhC";
export var medal = "Icon-module--medal--3VzCD";
export var segments = "Icon-module--segments--3LJD7";